import type { ViewerConfig, ViewerTheme } from "./contracts"

export const defaultTheme: ViewerTheme = Object.freeze({
  background: "#ffffff",
  grid: "#e8e8e8",
  selection: "#111111",
  labelBackground: "rgba(255, 255, 255, 0.8)",
  labelText: "#111111",
  minimapBackground: "#f4f4f4",
  minimapViewport: "rgba(0, 0, 0, 0.15)",
  minimapViewportStroke: "rgba(0, 0, 0, 0.5)",
})

export const darkTheme: ViewerTheme = Object.freeze({
  background: "#0a0a0a",
  grid: "#1a1a1a",
  selection: "#fafafa",
  labelBackground: "rgba(10, 10, 10, 0.7)",
  labelText: "#fafafa",
  minimapBackground: "#111111",
  minimapViewport: "rgba(255, 255, 255, 0.25)",
  minimapViewportStroke: "rgba(255, 255, 255, 0.6)",
})

export const defaultConfig: Readonly<ViewerConfig> = Object.freeze({
  gridSize: 20,
  edgeWidth: 1.5,
  dimAlpha: 0.08,
  layoutDirection: "DOWN",
  showLabels: true,
})
